import tw from "twin.macro";

export const Sheet = tw.div`
  bg-gray rounded-xl w-full flex flex-col p-4 mt-8
`;
